<template>
  <div class="config-page">
    <!-- 顶部标题 -->
    <div class="optional-title">{{ $t('series.optional_title') }}<span class="optional-title2"> {{ $t('series.optional_title2') }}</span></div>
    <!-- 卡片容器，分为左右两部分 -->
    <div class="cards-container">
      <!-- 左侧卡片区域 -->
      <div class="left-cards">
        <!-- 上面两个竖形卡片 -->
        <div class="top-two-cards vertical-cards">
          <div ref="top-two-cards" class="card" v-for="(item, index) in leftTopCards" :key="index">
            <div class="card-plus">+</div>
            <img :src="item.image" alt="card-img" class="card-img"/>
            <div class="card-title">{{ item.title }}</div>
          </div>
        </div>
        <!-- 下面部分，左侧一个卡片，右侧两个卡片 -->
        <div class="bottom-cards">
          <div class="bottom-left-card" ref="left-bottom-card">
            <div class="card card-large">
              <div class="card-plus">+</div>
              <img :src="bottomLeftCard.image" alt="card-img" class="card-img"/>
              <div class="card-title">{{ bottomLeftCard.title }}</div>
            </div>
          </div>
          <div class="bottom-right-cards">
            <div ref="left-bottom-card" class="card" v-for="(item, index) in bottomRightCards" :key="index">
              <div class="card-plus">+</div>
              <img :src="item.image" alt="card-img" class="card-img"/>
              <div class="card-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧卡片区域 -->
      <div class="right-cards">
        <!-- 上面两个横形卡片 -->
        <div class="top-two-cards horizontal-cards">
          <div ref="right-top-two" class="card" v-for="(item, index) in rightTopCards" :key="index">
            <div class="card-plus">+</div>
            <img :src="item.image" alt="card-img" class="card-img"/>
            <div class="card-title">{{ item.title }}</div>
          </div>
        </div>

        <!-- 下面三列两行的卡片 -->
        <div class="bottom-grid-cards">
          <div ref="right-bottom-three" class="card card-small" v-for="(item, index) in rightBottomCards" :key="index">
            <div class="card-plus">+</div>
            <img :src="item.image" alt="card-img" class="card-img"/>
            <div class="card-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from "../../static/series/OptionalSelection/图片1.png"
import image2 from "../../static/series/OptionalSelection/图片2.png"
import image3 from "../../static/series/OptionalSelection/图片5.png"
import image4 from "../../static/series/OptionalSelection/图片6.png"
import image5 from "../../static/series/OptionalSelection/图片7.png"
import image6 from "../../static/series/OptionalSelection/图片3.png"
import image7 from "../../static/series/OptionalSelection/图片14.png"
import image8 from "../../static/series/OptionalSelection/图片13.png"
import image9 from "../../static/series/OptionalSelection/图片12.png"
import image10 from "../../static/series/OptionalSelection/图片11.png"

import image11 from "../../static/series/OptionalSelection/图片8.png"
import image12 from "../../static/series/OptionalSelection/图片9.png"
import image13 from "../../static/series/OptionalSelection/图片10.png"

export default {
  name: 'OptionalSelection',
  data() {
    return {
      // 左侧上面两个卡片数据
      leftTopCards: [
        {
          image: image1,
          title: this.$i18n.t('series.SingleDrill'),
        },
        {
          image: image2,
          title: this.$i18n.t('series.DualDrill'),
        }
      ],
      // 左侧下面部分左侧卡片数据
      bottomLeftCard: {
        image: image3,
        title: this.$i18n.t('series.SmartFeedingSystem'),
      },
      // 左侧下面部分右侧两个卡片数据
      bottomRightCards: [
        {
          image: image4,
          title: this.$i18n.t('series.CenteringTracker'),
        },
        {
          image: image5,
          title: this.$i18n.t('series.SaasAccess'),
        }
      ],
      // 右侧上面两个卡片数据
      rightTopCards: [
        {
          image: image6,
          title: this.$i18n.t('series.KnifeCooling'),
        },
        {
          image: image7,
          title: this.$i18n.t('series.Pre_Film'),
        }
      ],
      // 右侧下面三列两行卡片数据
      rightBottomCards: [
        {
          image: image8,
          title: this.$i18n.t('series.Secondary'),
        },
        {
          image: image9,
          title: this.$i18n.t('series.Vacuum'),
        },
        {
          image: image10,
          title: this.$i18n.t('series.Scanner'),
        },
        {
          image: image11,
          title: this.$i18n.t('series.BrokenKnife'),
        },
        {
          image: image12,
          title: this.$i18n.t('series.Floating'),
        },
        {
          image: image13,
          title: this.$i18n.t('series.Relocating'),
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.bottom-cards',
          start: 'top 80%',
          end: 'bottom 20',
          markers: false,
          once: true,
          toggleActions: 'play none none none',
        }
      })
      masterTimeline
          .from('.optional-title', {
            opacity: 1,
            y: '22vw',
            x: '22vw',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)
      masterTimeline
          .to('.optional-title', {
            color: '#808080',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)
      masterTimeline
          .to('.optional-title2', {
            color: '#46b1e1',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)

      // 卡片进场
      masterTimeline
          .from('.vertical-cards', {
            opacity: 0,
            y: '-15vw',
            x: '-15vw',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)

      masterTimeline
          .from('.bottom-cards', {
            opacity: 0,
            y: '15vw',
            x: '-15vw',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)

      masterTimeline
          .from('.horizontal-cards', {
            opacity: 0,
            y: '-15vw',
            x: '15vw',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)

      masterTimeline
          .from('.bottom-grid-cards', {
            opacity: 0,
            y: '15vw',
            x: '15vw',
            duration: 1.5,
            ease: 'power2.in'
          }, 0.1)


      // let topTwoCardsRefs = this.$refs['top-two-cards']
      // topTwoCardsRefs.push(...this.$refs['right-top-two'])
      // topTwoCardsRefs.push('.bottom-left-card')
      // topTwoCardsRefs.push(...this.$refs['left-bottom-card'])
      // topTwoCardsRefs.push(...this.$refs['right-bottom-three'])
      //
      // topTwoCardsRefs.forEach((item, index) => {
      //   masterTimeline.from(item, {
      //     opacity: 0,
      //     duration: 1.5,
      //     ease: 'power2.in'
      //   }, index * 0.2);
      // });

    })
  }
};
</script>

<style scoped>
/* 基础放大：通过根元素字体大小调整整体比例 */
html {
  font-size: 110%;
}

.config-page {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  max-width: 1600px;
  margin: 0 auto;
  margin-top: 350px;
}

.optional-title {
  font-size: var(--font-size-lg2);
  color: #000;
  margin-bottom: 30px;
  text-align: left;
}

.optional-title2 {
  color: #808080;
}

.cards-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.left-cards,
.right-cards {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 顶部两个卡片容器通用样式 */
.top-two-cards {
  display: flex;
  gap: 10px;
}

/* 左侧顶部竖形卡片样式 */
.vertical-cards {
  height: 380px;
}

.vertical-cards .card {
  flex: 1;
  width: 50%;
  min-width: 220px;
  display: flex;
  flex-direction: column;
}

/* 右侧顶部横形卡片样式 */
.horizontal-cards {
  height: 50%;
}

.horizontal-cards .card {
  flex: 1;
  min-width: 260px;
  display: flex;
  flex-direction: column;
}

/* 基础卡片样式 */
.card {
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: hidden; /* 确保内容不会超出卡片 */
}

/* 左侧底部大卡片 */
.card-large {
  height: 100%;
  padding: 20px;
}

/* 右侧底部小卡片 */
.card-small {
  padding: 15px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-plus {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 2em;
  color: black;
  z-index: 1;
}

/* 图片样式 - 核心调整：确保不超过卡片范围 */
.card-img {
  max-width: 100%; /* 图片宽度不超过卡片宽度 */
  max-height: 75%; /* 图片高度不超过卡片高度的70%，为文字留出空间 */
  width: auto; /* 保持宽高比 */
  height: auto; /* 保持宽高比 */
  flex: 1;
  margin: 10px 0;
  object-fit: contain; /* 完整显示图片，不裁剪 */
  object-position: center;
}

/* 大卡片图片调整 */
.card-large .card-img {
  max-height: 75%; /* 大卡片可分配更多高度给图片 */
  margin: 15px 0 10px;
}

/* 小卡片图片调整 */
.card-small .card-img {
  margin: 8px 0;
}

/* 横形卡片图片调整 */
.horizontal-cards .card-img {
}

/* 文字样式 */
.card-title {
  font-size: 1.2em;
  color: #333;
  line-height: 1.6;
  padding: 10px 5px;
  margin: 5px 0 10px;
  width: 100%;
  box-sizing: border-box;
}

/* 大卡片标题调整 */
.card-large .card-title {
  font-size: 17px;
  max-width: 100%;
  padding: 15px 10px;
}

/* 小卡片标题调整 */
.card-small .card-title {
  font-size: 1.1em;
  padding: 8px 5px;
}

/* 横形卡片标题调整 */
.horizontal-cards .card-title {
  font-size: 1.1em;
  max-width: 100%;
}

/* 左侧底部卡片容器 */
.bottom-cards {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  height: 450px;
}

.bottom-left-card {
  flex: 3;
}

.bottom-right-cards {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

/* 右侧底部网格卡片 */
.bottom-grid-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  height: 480px;
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .bottom-grid-cards {
    grid-template-columns: repeat(2, 1fr);
    height: auto;
  }
}

@media (max-width: 1100px) {
  .cards-container {
    flex-direction: column;
  }

  .bottom-cards {
    flex-direction: column;
    height: auto;
  }

  .bottom-left-card, .bottom-right-cards {
    width: 100%;
    flex: none;
  }

  .bottom-right-cards {
    flex-direction: row;
  }
}

@media (max-width: 868px) {
  .vertical-cards, .horizontal-cards {
    height: auto;
    flex-direction: column;
  }

  .vertical-cards .card, .horizontal-cards .card {
    width: 100%;
    height: auto;
    min-height: 320px;
  }

  .bottom-right-cards {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .bottom-grid-cards {
    grid-template-columns: 1fr;
  }

  html {
    font-size: 105%;
  }

  .card-img {
    max-height: 60%;
  }
}
</style>
